/* CART TEST: Restorative box vs the routine module (Oct 28 – Nov 22, 2026).
 * Plan + mockups: channels/shopify/simplify-site-2026-10/ (README §3, mockups/cart-restorative.html).
 * Loaded by snippets/cart-drawer-v2.liquid only while settings.cart_test_enabled is on.
 *
 * - Arm: drawn once per device (50/50, localStorage), or taken from the cart's
 *   `cart_test` attribute if the cart already has one. Set on <html data-cart-test>,
 *   which the drawer CSS reads to show either the routine module or the
 *   "Found in:" box. ?carttest=control|restorative forces an arm for checks;
 *   forced arms are written as `<arm>_qa` and never counted.
 * - The box also links to the routine builder page for anyone who'd rather pick
 *   their own (cart_test_builder).
 * - Seen: the first time the open drawer shows a qualifying cart (data-ct on the
 *   drawer), the arm is written to the cart attribute (so it rides on the order)
 *   and cart_test_view goes to the event log and GA4, once per cart.
 * - Restorative arm on the routine page: if the bag holds the routine's own
 *   products, the add button says what it replaces, and adding takes one of each
 *   out before the routine goes in. Control and everyone else: page unchanged.
 */
(function () {
  'use strict';

  var ENDPOINT = 'https://skin-quiz.elijah-8d4.workers.dev/c/e';
  var ARMS = ['control', 'restorative'];
  var ARM_KEY = 'mh:ct-arm', FORCE_KEY = 'mh:ct-force', SEEN_KEY = 'mh:ct-seen';
  var SHORT = { 'corrective-peptide-serum': 'Peptide', 'vitamin-a-serum': 'Super A', 'triple-c-night-cream': 'Triple C', 'cream-cleanser': 'Cream Cleanser' };

  function get(store, k) { try { return window[store].getItem(k); } catch (e) { return null; } }
  function set(store, k, v) { try { window[store].setItem(k, v); } catch (e) { /* private mode */ } }

  function root() { return document.querySelector('cart-drawer-root'); }
  function cfg() {
    try {
      var el = root() && root().querySelector('[data-cdv2-config]');
      return (el && JSON.parse(el.textContent).cartTest) || {};
    } catch (e) { return {}; }
  }

  // ---------- arm ----------
  var forced = null;
  try { forced = new URLSearchParams(location.search).get('carttest'); } catch (e) { /* no URL API */ }
  if (ARMS.indexOf(forced) >= 0) set('sessionStorage', FORCE_KEY, forced);
  else forced = get('sessionStorage', FORCE_KEY);
  if (ARMS.indexOf(forced) < 0) forced = null;

  function arm() {
    if (forced) return forced;
    var onCart = String(cfg().arm || '');
    if (ARMS.indexOf(onCart) >= 0) { set('localStorage', ARM_KEY, onCart); return onCart; }
    var a = get('localStorage', ARM_KEY);
    if (ARMS.indexOf(a) < 0) { a = Math.random() < 0.5 ? 'control' : 'restorative'; set('localStorage', ARM_KEY, a); }
    return a;
  }
  // what goes on the cart and in the log; '_qa' marks a forced check
  function armValue() { return forced ? forced + '_qa' : arm(); }
  function paint() { document.documentElement.setAttribute('data-cart-test', arm()); }

  // ---------- events ----------
  function device() { return window.matchMedia && matchMedia('(max-width: 767px)').matches ? 'mobile' : 'desktop'; }
  function envName() { return /(^|\.)madhippie\.com$/.test(location.hostname) && !forced ? 'prod' : 'test'; }
  function send(e, c) {
    var body = JSON.stringify({ v: 1, env: envName(), events: [{ e: e, arm: armValue(), cart: c.token, units: c.units, value: c.value, device: device(), ts: new Date().toISOString() }] });
    try {
      if (!(navigator.sendBeacon && navigator.sendBeacon(ENDPOINT, new Blob([body], { type: 'text/plain' })))) {
        fetch(ENDPOINT, { method: 'POST', body: body, keepalive: true, headers: { 'Content-Type': 'text/plain' } });
      }
    } catch (err) { /* analytics must never break the cart */ }
    try {
      if (typeof window.gtag === 'function') window.gtag('event', e, { cart_test_arm: armValue(), cart_units: c.units });
    } catch (err) { /* same */ }
  }

  // ---------- seen ----------
  // Liquid's cart.token renders empty on the live store, so the token (and the
  // attribute as it stands) come from /cart.js, once per open drawer. /cart.js
  // returns "token?key=…" but the order's cart_token has no key, so the key is
  // dropped here or the logged cart never matches its order.
  var written = {}, checking = false, lastToken = null;
  function drawerOpen(r) {
    var inst = r.closest('.drawer--instance');
    return inst ? inst.getAttribute('aria-expanded') === 'true' : !!r.offsetParent;
  }
  function seen() {
    var r = root(), c = cfg();
    if (!r || !c.on || !c.qualifies || r.getAttribute('data-ct') !== '1' || !drawerOpen(r) || checking) return;
    checking = true;
    fetch('/cart.js').then(function (res) { return res.json(); }).then(function (cart) {
      var token = cart && cart.token && String(cart.token).split('?')[0];
      if (!token) return;
      lastToken = token;
      var a = armValue();
      if ((cart.attributes || {}).cart_test !== a && !written[token]) {
        written[token] = true;
        fetch('/cart/update.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: { cart_test: a } })
        }).catch(function () { written[token] = false; });
      }
      var list = [];
      try { list = JSON.parse(get('localStorage', SEEN_KEY) || '[]'); } catch (e) { list = []; }
      if (list.indexOf(token) >= 0) return;
      list.push(token);
      set('localStorage', SEEN_KEY, JSON.stringify(list.slice(-20)));
      send('cart_test_view', { token: token, units: c.units, value: c.value });
    }).catch(function () { /* analytics must never break the cart */ }).then(function () { checking = false; });
  }
  function tapped() { var c = cfg(); return { token: lastToken, units: c.units, value: c.value }; }

  document.addEventListener('cdv2:rendered', function () { paint(); seen(); });
  var inst = document.querySelector('.drawer--instance[data-side="right"]');
  if (inst && window.MutationObserver) {
    new MutationObserver(function () { setTimeout(seen, 50); }).observe(inst, { attributes: true, attributeFilter: ['aria-expanded'] });
  }
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    if (e.target.closest('[data-ct-go]')) send('cart_test_click', tapped());
    else if (e.target.closest('[data-ct-builder]')) send('cart_test_builder', tapped());
  }, true);
  paint();
  seen();

  // ---------- routine page: add replaces the singles already in the bag ----------
  var c0 = cfg();
  var form = document.getElementById('hero-product-form');
  if (!form || !c0.on || !c0.routine || arm() !== 'restorative') return;
  if (location.pathname.indexOf('/products/' + c0.routine) < 0) return;
  // the routine's own products (a wider list than the trigger: a cart that came in on the Peptide may also hold the cleanser)
  var singles = String(c0.contents || '').split(',').filter(Boolean);
  var swap = null; // { updates: {lineKey: newQty}, units, names }

  function plan(cart) {
    var p = { updates: {}, units: 0, names: [] };
    var done = {};
    (cart.items || []).forEach(function (it) {
      if (singles.indexOf(it.handle) < 0 || done[it.handle]) return;
      if (it.properties && it.properties._source === 'quiz') return;
      done[it.handle] = true;
      p.updates[it.key] = it.quantity - 1;
      p.units += 1;
      p.names.push(SHORT[it.handle] || it.product_title);
    });
    return p.units ? p : null;
  }
  // product-hero-v3-core.js rewrites the button's innerHTML (variant init, price
  // updates), so the label is put back whenever the button changes. It only
  // writes when the text differs, so it can't loop.
  var was = null;
  function label() {
    var btn = document.getElementById('hero-cta-button');
    var txt = btn && btn.querySelector('.cta-text');
    if (!txt) return;
    var show = function (sel, on) { btn.querySelectorAll(sel).forEach(function (el) { el.style.display = on ? '' : 'none'; }); };
    if (swap) {
      var want = swap.units === 1 ? 'Add, replaces your ' + swap.names[0] : 'Add, replaces ' + swap.units + ' items in your bag';
      if (txt.textContent !== want) { if (was === null) was = txt.textContent; txt.textContent = want; }
      // the price is printed right under the button; the button carries the swap
      show('.cta-separator, .cta-price-compare, .cta-price', false);
    } else if (was !== null) {
      txt.textContent = was; was = null;
      show('.cta-separator, .cta-price-compare, .cta-price', true);
    }
  }
  var heroBtn = document.getElementById('hero-cta-button');
  if (heroBtn && window.MutationObserver) {
    new MutationObserver(function () { if (swap) label(); }).observe(heroBtn, { childList: true, subtree: true, characterData: true });
  }
  function refreshPlan() {
    return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) { swap = plan(cart); label(); }).catch(function () {});
  }
  refreshPlan();
  document.addEventListener('cdv2:rendered', refreshPlan);

  // Runs before the hero's own submit handler (capture on document). Takes the
  // singles out, then hands the same submit back to the hero, which adds the
  // routine and opens the drawer as usual. A subscription add goes to Loop
  // untouched.
  var passing = false;
  document.addEventListener('submit', function (e) {
    if (e.target !== form || passing || !swap) return;
    if (form.querySelector('input[name="purchase-option"][value="subscribe"]:checked')) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var updates = swap.updates;
    fetch('/cart/update.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: updates })
    }).catch(function () {}).then(function () {
      swap = null;
      passing = true;
      form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
      passing = false;
      label();
    });
  }, true);
})();
